// extracted by mini-css-extract-plugin
export default {"heading":"gMR5c"};